import { EXTERNAL_LINKS_STATE } from 'constants/constants';

export enum RemediationRuleViews {
  ExternalLinks = 'ExternalLinks',
}

/**
 * Angular router states of the remediation rule pages migrated to React.
 * To add a new rule page: add an enum member, map its state here and register
 * its component in RULE_VIEW_COMPONENTS — routing picks it up automatically.
 */
export const REMEDIATION_RULE_VIEW_STATES: Record<RemediationRuleViews, string> = {
  [RemediationRuleViews.ExternalLinks]: EXTERNAL_LINKS_STATE,
};

enum BaseViews {
  InitialPage = 'InitialPage',
  InitialPageLst = 'InitialPageLst',
  ReportPage = 'ReportPage',
  AboutPage = 'AboutPage',
  HowItWorksPage = 'HowItWorksPage',
  SkeletonPage = 'SkeletonPage',
  Login = 'Login',
  ForgotPassword = 'ForgotPassword',
  Recovery = 'Recovery',
  Manage = 'Manage',
  LstUpgrade = 'LstUpgrade',
  RemediationsList = 'RemediationsList',
  AddonsAndSettings = 'AddonsAndSettings',
}

export const ViewsList = { ...BaseViews, ...RemediationRuleViews };

export type Views = BaseViews | RemediationRuleViews;
